import { runDemo } from "../shared/demoRunner";
import { createDisplacementMapScene } from "./scene";

runDemo({ createScene: createDisplacementMapScene });
